<template>
    <div class='wrapper'>
        <div class="title">
            <img src="../payPage/imgs/biggou.png" alt="" style="width: 24px;height:24px;margin-right:20px">
            <p class="cong">恭喜您 购买成功</p>
        </div>
        <div class="content">
            <img src="../payPage/imgs/biggou.png" alt="" class="biggou">
            <div class="infobox">
                <p style="color:rgba(8, 193, 96, 1);font-size:18px;">恭喜您购买成功</p>
                <p style="font-size:14px;"> <span style="color:rgba(255, 126, 0,1)">4</span> 秒跳转页面</p>
                <button>点击立即跳转</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index.vue"
    }
</script>

<style scoped>
    p{
        margin: 0;
        padding: 0;
    }
    .wrapper{
        width: 1200px;
        margin: 0 auto;

    }
    .title{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 600px;
        height: 50px;
        background:rgba(242,253,237,1);
        margin: 0 auto;
        margin-top: 40px;
        margin-bottom: 20px;
        box-sizing: border-box;
    }
    .content{
        width: 600px;
        height:270px;
        background:rgba(255,255,255,1);
        box-shadow:0px 5px 15px 0px rgba(0, 0, 0, 0.2);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }
    .biggou{
        display:block;
        box-sizing: border-box;
        width: 90px;
        height: 90px;
        margin-right: 20px;
    }
    .infobox{
        text-align: center;
        height: 90px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }
    .cong{
        font-size:16px;
        font-family:Source Han Sans CN;
        font-weight:500;
        color:rgba(51,51,51,1);
        text-align: center;
    }
    button{
        width: 150px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        background: rgba(8, 193, 96, 1);
        color:#fff;
        border: none;
        font-size: 16px;
    }
</style>